import { render } from "./PlantEvaluationsForPlants.vue?vue&type=template&id=4d6e5ee8"
import script from "./PlantEvaluationsForPlants.vue?vue&type=script&lang=js"
export * from "./PlantEvaluationsForPlants.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__